import * as React from "react";
import {Syllabary} from "../WordFetcher";
import styled from "styled-components";
import {Accordion} from "semantic-ui-react";
import Icon from "semantic-ui-react/dist/commonjs/elements/Icon";

interface IProps {
    knownCharacters: string,
    currentWord: string,
    currentSyllabary: Syllabary,
}

interface IState {
    show: boolean,
}

export class KnownCharacterTable extends React.Component<IProps, IState> {
    private readonly storageKey = 'showKnownCharacters';


    constructor(props: IProps) {
        super(props);
        this.toggleShow.bind(this);

        let showKnownCharacters: boolean = true;
        let storedValue: string | null = localStorage.getItem(this.storageKey);
        if (storedValue) {
            try {
                showKnownCharacters = JSON.parse(storedValue)
            } catch {
                showKnownCharacters = true;
            }
        }
        this.state = {
            show: showKnownCharacters,
        }
    }

    public render() {
        let tableContent;
        if (this.props.currentSyllabary == Syllabary.hiragana) {
            tableContent = this.renderHiraganaTable();
        } else {
            tableContent = this.renderKatakanaTable();
        }
        return (
            <CharacterTableContainer>
                <Accordion>
                    <StyledAccordionTitle active={this.state.show} onClick={() => { this.toggleShow() }}>
                        <StyledIcon name='dropdown'/> Kana table
                    </StyledAccordionTitle>
                    <Accordion.Content active={this.state.show}>
                        {tableContent}
                    </Accordion.Content>
                </Accordion>
            </CharacterTableContainer>
        )
    }

    private toggleShow() {
        let show = !this.state.show;
        localStorage.setItem(this.storageKey, JSON.stringify(show));
        this.setState({
            show: show,
        });
    }

    private renderKatakanaTable() {
        return (
            <table>
                <tbody>
                <tr>
                    <th></th>
                    <th><i>a</i></th>
                    <th><i>i</i></th>
                    <th><i>u</i></th>
                    <th><i>e</i></th>
                    <th><i>o</i></th>
                    <th>∅</th>
                </tr>
                <tr>
                    <th>∅</th>
                    <CharacterCell {...this.propsFor('ア')}>ア</CharacterCell>
                    <CharacterCell {...this.propsFor('イ')}>イ</CharacterCell>
                    <CharacterCell {...this.propsFor('ウ')}>ウ</CharacterCell>
                    <CharacterCell {...this.propsFor('エ')}>エ</CharacterCell>
                    <CharacterCell {...this.propsFor('オ')}>オ</CharacterCell>
                </tr>
                <tr>
                    <th><i>k</i></th>
                    <CharacterCell {...this.propsFor('カ')}>カ</CharacterCell>
                    <CharacterCell {...this.propsFor('キ')}>キ</CharacterCell>
                    <CharacterCell {...this.propsFor('ク')}>ク</CharacterCell>
                    <CharacterCell {...this.propsFor('ケ')}>ケ</CharacterCell>
                    <CharacterCell {...this.propsFor('コ')}>コ</CharacterCell>
                </tr>
                <tr>
                    <th><i>g</i></th>
                    <CharacterCell {...this.propsFor('ガ')}>ガ</CharacterCell>
                    <CharacterCell {...this.propsFor('ギ')}>ギ</CharacterCell>
                    <CharacterCell {...this.propsFor('グ')}>グ</CharacterCell>
                    <CharacterCell {...this.propsFor('ゲ')}>ゲ</CharacterCell>
                    <CharacterCell {...this.propsFor('ゴ')}>ゴ</CharacterCell>
                </tr>
                <tr>
                    <th><i>s</i></th>
                    <CharacterCell {...this.propsFor('サ')}>サ</CharacterCell>
                    <CharacterCell {...this.propsFor('シ')}>シ</CharacterCell>
                    <CharacterCell {...this.propsFor('ス')}>ス</CharacterCell>
                    <CharacterCell {...this.propsFor('セ')}>セ</CharacterCell>
                    <CharacterCell {...this.propsFor('ソ')}>ソ</CharacterCell>
                </tr>
                <tr>
                    <th><i>z</i></th>
                    <CharacterCell {...this.propsFor('ザ')}>ザ</CharacterCell>
                    <CharacterCell {...this.propsFor('ジ')}>ジ</CharacterCell>
                    <CharacterCell {...this.propsFor('ズ')}>ズ</CharacterCell>
                    <CharacterCell {...this.propsFor('ゼ')}>ゼ</CharacterCell>
                    <CharacterCell {...this.propsFor('ゾ')}>ゾ</CharacterCell>
                </tr>
                <tr>
                    <th><i>t</i></th>
                    <CharacterCell {...this.propsFor('タ')}>タ</CharacterCell>
                    <CharacterCell {...this.propsFor('チ')}>チ</CharacterCell>
                    <CharacterCell {...this.propsFor('ツ')}>ツ</CharacterCell>
                    <CharacterCell {...this.propsFor('テ')}>テ</CharacterCell>
                    <CharacterCell {...this.propsFor('ト')}>ト</CharacterCell>
                </tr>
                <tr>
                    <th><i>d</i></th>
                    <CharacterCell {...this.propsFor('ダ')}>ダ</CharacterCell>
                    <CharacterCell {...this.propsFor('ヂ')}>ヂ</CharacterCell>
                    <CharacterCell {...this.propsFor('ヅ')}>ヅ</CharacterCell>
                    <CharacterCell {...this.propsFor('デ')}>デ</CharacterCell>
                    <CharacterCell {...this.propsFor('ド')}>ド</CharacterCell>
                </tr>
                <tr>
                    <th><i>n</i></th>
                    <CharacterCell {...this.propsFor('ナ')}>ナ</CharacterCell>
                    <CharacterCell {...this.propsFor('ニ')}>ニ</CharacterCell>
                    <CharacterCell {...this.propsFor('ヌ')}>ヌ</CharacterCell>
                    <CharacterCell {...this.propsFor('ネ')}>ネ</CharacterCell>
                    <CharacterCell {...this.propsFor('ノ')}>ノ</CharacterCell>
                    <CharacterCell {...this.propsFor('ン')}>ン</CharacterCell>
                </tr>
                <tr>
                    <th><i>h</i></th>
                    <CharacterCell {...this.propsFor('ハ')}>ハ</CharacterCell>
                    <CharacterCell {...this.propsFor('ヒ')}>ヒ</CharacterCell>
                    <CharacterCell {...this.propsFor('フ')}>フ</CharacterCell>
                    <CharacterCell {...this.propsFor('ヘ')}>ヘ</CharacterCell>
                    <CharacterCell {...this.propsFor('ホ')}>ホ</CharacterCell>
                </tr>
                <tr>
                    <th><i>b</i></th>
                    <CharacterCell {...this.propsFor('バ')}>バ</CharacterCell>
                    <CharacterCell {...this.propsFor('ビ')}>ビ</CharacterCell>
                    <CharacterCell {...this.propsFor('ブ')}>ブ</CharacterCell>
                    <CharacterCell {...this.propsFor('ベ')}>ベ</CharacterCell>
                    <CharacterCell {...this.propsFor('ボ')}>ボ</CharacterCell>
                </tr>
                <tr>
                    <th><i>p</i></th>
                    <CharacterCell {...this.propsFor('パ')}>パ</CharacterCell>
                    <CharacterCell {...this.propsFor('ピ')}>ピ</CharacterCell>
                    <CharacterCell {...this.propsFor('プ')}>プ</CharacterCell>
                    <CharacterCell {...this.propsFor('ペ')}>ペ</CharacterCell>
                    <CharacterCell {...this.propsFor('ポ')}>ポ</CharacterCell>
                </tr>
                <tr>
                    <th><i>m</i></th>
                    <CharacterCell {...this.propsFor('マ')}>マ</CharacterCell>
                    <CharacterCell {...this.propsFor('ミ')}>ミ</CharacterCell>
                    <CharacterCell {...this.propsFor('ム')}>ム</CharacterCell>
                    <CharacterCell {...this.propsFor('メ')}>メ</CharacterCell>
                    <CharacterCell {...this.propsFor('モ')}>モ</CharacterCell>
                </tr>
                <tr>
                    <th><i>y</i></th>
                    <CharacterCell {...this.propsFor('ヤ')}>ヤ</CharacterCell>
                    <CharacterCell></CharacterCell>
                    <CharacterCell {...this.propsFor('ユ')}>ユ</CharacterCell>
                    <CharacterCell></CharacterCell>
                    <CharacterCell {...this.propsFor('ヨ')}>ヨ</CharacterCell>
                </tr>
                <tr>
                    <th><i>r</i></th>
                    <CharacterCell {...this.propsFor('ラ')}>ラ</CharacterCell>
                    <CharacterCell {...this.propsFor('リ')}>リ</CharacterCell>
                    <CharacterCell {...this.propsFor('ル')}>ル</CharacterCell>
                    <CharacterCell {...this.propsFor('レ')}>レ</CharacterCell>
                    <CharacterCell {...this.propsFor('ロ')}>ロ</CharacterCell>
                </tr>
                <tr>
                    <th><i>w</i></th>
                    <CharacterCell {...this.propsFor('ワ')}>ワ</CharacterCell>
                    <CharacterCell></CharacterCell>
                    <CharacterCell></CharacterCell>
                    <CharacterCell></CharacterCell>
                    <CharacterCell {...this.propsFor('ヲ')}>ヲ</CharacterCell>
                </tr>
                </tbody>
            </table>
        )
    };

    private renderHiraganaTable() {
        return (
            <table>
                <tbody>
                <tr>
                    <th></th>
                    <th><i>a</i></th>
                    <th><i>i</i></th>
                    <th><i>u</i></th>
                    <th><i>e</i></th>
                    <th><i>o</i></th>
                    <th>∅</th>
                </tr>
                <tr>
                    <th>∅</th>
                    <CharacterCell {...this.propsFor('あ')}>あ</CharacterCell>
                    <CharacterCell {...this.propsFor('い')}>い</CharacterCell>
                    <CharacterCell {...this.propsFor('う')}>う</CharacterCell>
                    <CharacterCell {...this.propsFor('え')}>え</CharacterCell>
                    <CharacterCell {...this.propsFor('お')}>お</CharacterCell>
                </tr>
                <tr>
                    <th><i>k</i></th>
                    <CharacterCell {...this.propsFor('か')}>か</CharacterCell>
                    <CharacterCell {...this.propsFor('き')}>き</CharacterCell>
                    <CharacterCell {...this.propsFor('く')}>く</CharacterCell>
                    <CharacterCell {...this.propsFor('け')}>け</CharacterCell>
                    <CharacterCell {...this.propsFor('こ')}>こ</CharacterCell>
                </tr>
                <tr>
                    <th><i>g</i></th>
                    <CharacterCell {...this.propsFor('が')}>が</CharacterCell>
                    <CharacterCell {...this.propsFor('ぎ')}>ぎ</CharacterCell>
                    <CharacterCell {...this.propsFor('ぐ')}>ぐ</CharacterCell>
                    <CharacterCell {...this.propsFor('げ')}>げ</CharacterCell>
                    <CharacterCell {...this.propsFor('ご')}>ご</CharacterCell>
                </tr>
                <tr>
                    <th><i>s</i></th>
                    <CharacterCell {...this.propsFor('さ')}>さ</CharacterCell>
                    <CharacterCell {...this.propsFor('し')}>し</CharacterCell>
                    <CharacterCell {...this.propsFor('す')}>す</CharacterCell>
                    <CharacterCell {...this.propsFor('せ')}>せ</CharacterCell>
                    <CharacterCell {...this.propsFor('そ')}>そ</CharacterCell>
                </tr>
                <tr>
                    <th><i>z</i></th>
                    <CharacterCell {...this.propsFor('ざ')}>ざ</CharacterCell>
                    <CharacterCell {...this.propsFor('じ')}>じ</CharacterCell>
                    <CharacterCell {...this.propsFor('ず')}>ず</CharacterCell>
                    <CharacterCell {...this.propsFor('ぜ')}>ぜ</CharacterCell>
                    <CharacterCell {...this.propsFor('ぞ')}>ぞ</CharacterCell>
                </tr>
                <tr>
                    <th><i>t</i></th>
                    <CharacterCell {...this.propsFor('た')}>た</CharacterCell>
                    <CharacterCell {...this.propsFor('ち')}>ち</CharacterCell>
                    <CharacterCell {...this.propsFor('つ')}>つ</CharacterCell>
                    <CharacterCell {...this.propsFor('て')}>て</CharacterCell>
                    <CharacterCell {...this.propsFor('と')}>と</CharacterCell>
                </tr>
                <tr>
                    <th><i>d</i></th>
                    <CharacterCell {...this.propsFor('だ')}>だ</CharacterCell>
                    <CharacterCell {...this.propsFor('ぢ')}>ぢ</CharacterCell>
                    <CharacterCell {...this.propsFor('づ')}>づ</CharacterCell>
                    <CharacterCell {...this.propsFor('で')}>で</CharacterCell>
                    <CharacterCell {...this.propsFor('ど')}>ど</CharacterCell>
                </tr>
                <tr>
                    <th><i>n</i></th>
                    <CharacterCell {...this.propsFor('な')}>な</CharacterCell>
                    <CharacterCell {...this.propsFor('に')}>に</CharacterCell>
                    <CharacterCell {...this.propsFor('ぬ')}>ぬ</CharacterCell>
                    <CharacterCell {...this.propsFor('ね')}>ね</CharacterCell>
                    <CharacterCell {...this.propsFor('の')}>の</CharacterCell>
                    <CharacterCell {...this.propsFor('ん')}>ん</CharacterCell>
                </tr>
                <tr>
                    <th><i>h</i></th>
                    <CharacterCell {...this.propsFor('は')}>は</CharacterCell>
                    <CharacterCell {...this.propsFor('ひ')}>ひ</CharacterCell>
                    <CharacterCell {...this.propsFor('ふ')}>ふ</CharacterCell>
                    <CharacterCell {...this.propsFor('へ')}>へ</CharacterCell>
                    <CharacterCell {...this.propsFor('ほ')}>ほ</CharacterCell>
                </tr>
                <tr>
                    <th><i>b</i></th>
                    <CharacterCell {...this.propsFor('ば')}>ば</CharacterCell>
                    <CharacterCell {...this.propsFor('び')}>び</CharacterCell>
                    <CharacterCell {...this.propsFor('ぶ')}>ぶ</CharacterCell>
                    <CharacterCell {...this.propsFor('べ')}>べ</CharacterCell>
                    <CharacterCell {...this.propsFor('ぼ')}>ぼ</CharacterCell>
                </tr>
                <tr>
                    <th><i>p</i></th>
                    <CharacterCell {...this.propsFor('ぱ')}>ぱ</CharacterCell>
                    <CharacterCell {...this.propsFor('ぴ')}>ぴ</CharacterCell>
                    <CharacterCell {...this.propsFor('ぷ')}>ぷ</CharacterCell>
                    <CharacterCell {...this.propsFor('ぺ')}>ぺ</CharacterCell>
                    <CharacterCell {...this.propsFor('ぽ')}>ぽ</CharacterCell>
                </tr>
                <tr>
                    <th><i>m</i></th>
                    <CharacterCell {...this.propsFor('ま')}>ま</CharacterCell>
                    <CharacterCell {...this.propsFor('み')}>み</CharacterCell>
                    <CharacterCell {...this.propsFor('む')}>む</CharacterCell>
                    <CharacterCell {...this.propsFor('め')}>め</CharacterCell>
                    <CharacterCell {...this.propsFor('も')}>も</CharacterCell>
                </tr>
                <tr>
                    <th><i>y</i></th>
                    <CharacterCell {...this.propsFor('や')}>や</CharacterCell>
                    <CharacterCell></CharacterCell>
                    <CharacterCell {...this.propsFor('ゆ')}>ゆ</CharacterCell>
                    <CharacterCell></CharacterCell>
                    <CharacterCell {...this.propsFor('よ')}>よ</CharacterCell>
                </tr>
                <tr>
                    <th><i>r</i></th>
                    <CharacterCell {...this.propsFor('ら')}>ら</CharacterCell>
                    <CharacterCell {...this.propsFor('り')}>り</CharacterCell>
                    <CharacterCell {...this.propsFor('る')}>る</CharacterCell>
                    <CharacterCell {...this.propsFor('れ')}>れ</CharacterCell>
                    <CharacterCell {...this.propsFor('ろ')}>ろ</CharacterCell>
                </tr>
                <tr>
                    <th><i>w</i></th>
                    <CharacterCell {...this.propsFor('わ')}>わ</CharacterCell>
                    <CharacterCell></CharacterCell>
                    <CharacterCell></CharacterCell>
                    <CharacterCell></CharacterCell>
                    <CharacterCell {...this.propsFor('を')}>を</CharacterCell>
                </tr>
                </tbody>
            </table>
        )
    };

    private propsFor(char: string): Props {
        let props: Props = {};
        if (this.props.knownCharacters.split('').some(known => known == char)) {
            props.known = true;
        } else {
            props.unknown = true;
        }
        if (this.props.currentWord.includes(char)) {
            props.current = true;
        }
        return props
    }
}

interface Props {
    known?: boolean;
    unknown?: boolean;
    current?: boolean;
}

const CharacterCell = styled.td`
  font-weight: ${(props: Props) => props.known ? "normal" : (props.unknown ? "lighter" : "bold")};
  background-color: ${(props: Props) => props.current ? props => props.theme.highlightColor : "inherit"};
  border-radius: 4px;
  color: ${(props: Props) => props.current ? "black" :
    (props.unknown ? props => props.theme.lightColor : "inherit")};
`;

const CharacterTableContainer = styled.div`
  font-family:  ${props => props.theme.japaneseFont};
  background: ${props => props.theme.transparentBackground};
  padding: 1em;
  border-radius: 0.5em;
  font-size: 1.2em;
  width: 180px;
`;

const StyledAccordionTitle = styled(Accordion.Title)`
  text-align: left;
  font-size: 1.5em;
`;

const StyledIcon = styled(Icon)`
  color: ${props => props.theme.lightColor};
`


// WEBPACK FOOTER //
// ./src/components/KnownCharacterTable.tsx